$(function($){

  // Add class to body 
  $('body').addClass('doc-ready')

  // svg polyfill for IE
  svg4everybody(); 

  // Lazy load
  let lazyLoad = $('.lazy').Lazy({
    chainable: false,
    effect: 'fadeIn',
    effectTime: 500,
    visibleOnly: true
  }); 

  $('.horizontal-lazy').Lazy({
    appendScroll: $('div'),
    visibleOnly: true
  });

  $(document).ajaxSuccess(function(event, xhr, settings ) {

    lazyLoad.addItems('.lazy')
    lazyLoad.update();

  });

  // Hidden menu
  $('.hamburger-btn, .close-menu').on('click', function(e) {
    e.preventDefault();

    $('body').toggleClass('overflow-hidden');
    $('.global-overlay').fadeToggle();
    $('.hidden-menu-wrapper').toggleClass('is-open');
  });

  $('.global-overlay').on('click', function(e) {
    e.preventDefault();

    $('body').removeClass('overflow-hidden');
    $('.global-overlay').fadeOut();
    $('.modal-wrapper').fadeOut();
    $('.hidden-menu-wrapper').removeClass('is-open');
  });

  // Menu search
  $('.search, .close-search').on('click', function(e) {
    e.preventDefault();

    $('.search-form').fadeToggle();
  });

});
